import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { OtpOption } from 'src/app/models/otp-option';
import { OtpService } from 'src/app/api/otp.service';
import { OtpRequestType } from 'src/app/models/otp-option';

@Component({
  selector: 'otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrls: ['./otp-modal.component.scss']
})
export class OtpModalComponent implements OnInit, OnChanges {
  @Input() show: boolean;
  @Input() otpType: OtpRequestType;
  @Input() buttonLabel: string;

  @Output() close = new EventEmitter<void>();
  @Output() otpSubmit = new EventEmitter<string>();

  otpOptions: OtpOption[];
  otpOption: OtpOption;

  otpLoading = true;
  otpError: string = null;
  success = false;

  phoneNumber: string = null;

  otpForm = this.fb.group({
    'code': ['', [Validators.required, Validators.minLength(6)]]
  });

  constructor(private otpService: OtpService, private fb: FormBuilder) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.show?.previousValue !== changes.show?.currentValue && changes.show?.currentValue) {
      // request on open
      this.getOtpOptions();
    }
  }

  getOtpOptions() {
    this.otpLoading = true;
    this.otpError = null;

    this.otpService.getOtpOptions(this.otpType).subscribe(response => {
      this.otpOptions = response;

      if (this.otpOptions.includes(OtpOption.TOTP)) {
        this.otpOption = OtpOption.TOTP;
        this.otpLoading = false;
      } else {
        this.otpOption = OtpOption.SMS;
        this.sendSMS();
      }

    }, err => {
      this.otpLoading = false;
      this.otpError = err?.errors?.[0]?.message;
    });
  }

  sendSMS() {
    this.otpLoading = true;
    this.otpError = null;
    this.phoneNumber = null;

    this.otpService.sendOtp(this.otpType, OtpOption.SMS).subscribe(response => {
      this.otpLoading = false;
      this.phoneNumber = response.maskedPhoneNumber;
    }, err => {
      this.otpLoading = false;
      this.otpError = err.errors[0].message;
    });

    return false;
  }

  onSubmitOTP() {
    const otp = this.otpCode.value;
    this.otpCode.setValue('');
    this.otpSubmit.emit(otp);
  }

  closeOtpForm() {
    this.otpCode.setValue('');
    this.close.emit();
  }

  isSMS() {
    return this.otpOption === OtpOption.SMS;
  }

  isTOTP() {
    return this.otpOption === OtpOption.TOTP;
  }

  isSmsEnabled() {
    return this.otpOptions && this.otpOptions.includes(OtpOption.SMS);
  }

  useSMS() {
    this.otpOption = OtpOption.SMS;
    this.sendSMS();
    return false;
  }

  get otpCode() { return this.otpForm.get('code'); }

}
